import { Injectable } from '@angular/core';
import { ApiService, RepositoryImpl } from '@eceos/arch';

import { Queue } from './queue';

@Injectable({ providedIn: 'root' })
export class QueuesRepository extends RepositoryImpl<Queue, Queue> {
  constructor(api: ApiService) {
    super(api.root.path('equeue').path('queues'), Queue, Queue);
  }
}
